export default "__VITE_ASSET__b2064cec__"